var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0522 9.67078C13.2352 9.85384 13.2352 10.1506 13.0522 10.3337L8.27312 15.1127C8.09006 15.2958 7.79331 15.2958 7.61025 15.1127L7.38925 14.8917C7.20619 14.7087 7.20619 14.4119 7.38925 14.2288L11.6159 10.0022L7.38925 5.77559C7.20619 5.59253 7.20619 5.29578 7.38925 5.11272L7.61025 4.89172C7.79331 4.70866 8.09006 4.70866 8.27312 4.89172L13.0522 9.67078Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.3ac3a2e90e4cc1dc301384b41b256414.svg";
export { ForwardRef as ReactComponent };